import { ChangeDetectorRef, Component, EventEmitter, OnInit, Output } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { CollectionConfigService } from '../../../../../core/collection-config/collection-config.service';

@Component({
  selector: 'kt-sap-filter',
  templateUrl: './sap-filter.component.html',
  styleUrls: ['./sap-filter.component.scss']
})
export class SapFilterComponent implements OnInit {
  @Output() onFilterApply = new EventEmitter<any>();
  @Output() filterChanged = new EventEmitter<boolean>(); // Notify parent about validity

  dynamicForm: UntypedFormGroup;
  fields: any[] = [];
  checks: string[] = [];
  SapNotification: any = [];

  constructor(
    private readonly fb: UntypedFormBuilder,
    private readonly _changeDetectorRef: ChangeDetectorRef,
    private readonly collectionConfigService: CollectionConfigService
  ) {
    this.dynamicForm = this.fb.group({
      filters: this.fb.array([])
    });
    this.addFilter();
  }

  ngOnInit(): void {
    this.fields = this.collectionConfigService.getData();  // Extract fields and store them
  }

  get filters() {
    return this.dynamicForm.get('filters') as UntypedFormArray;
  }

  createFilter(): UntypedFormGroup {
    return this.fb.group({
      selectedField: [null, Validators.required],
      selectedCheck: [null, Validators.required],
      dropDownInputValue: [null, Validators.required]
    });
  }

  addFilter() {
    this.filters.push(this.createFilter());
  }

  removeFilter(index: number) {
    this.filters.removeAt(index);
  }

  getOperators(selectedField: string): string[] {   // Get operators dynamically when field changes
    const field = this.fields.find(f => f.name === selectedField);
    return field ? field.operators : ['Please select fields'];
  }

  getValue(selectedField: string): string[] {
    const field = this.fields.find(f => f.name === selectedField);
    return field ? field.values : ['Please select fields'];
  }

  onFieldChange(event: any, index: number) {
    let selectedField = event.value;
    let fieldData = this.fields.find(f => f.name === selectedField);
    let filterGroup = this.filters.at(index) as UntypedFormGroup;

    // Determine the expected control name based on field type
    let expectedControl = fieldData?.isDropDown
      ? 'dropDownInputValue'
      : fieldData?.isDateField
        ? 'dateInputvalue'
        : fieldData?.isInputField
          ? 'inputValue'
          : null;

    // Remove any existing control that is not the expected one
    ['dropDownInputValue', 'dateInputvalue', 'inputValue'].forEach((control) => {
      if (control !== expectedControl && filterGroup.contains(control)) {
        filterGroup.removeControl(control);
      }
    });

    // Add the expected control if it does not already exist
    if (expectedControl && !filterGroup.contains(expectedControl)) {
      filterGroup.addControl(expectedControl, this.fb.control(null, Validators.required));
    }

    // Ensure the FormArray is updated and Angular detects changes
    this.filters.updateValueAndValidity();
    this._changeDetectorRef.detectChanges();
    this.validateFilters();
  }


  validateFilters() {
    const isValid = this.dynamicForm.valid;
    this.filterChanged.emit(isValid); // Emit event to parent
  }

  getMatFormType(selectedField, param) {
    if (selectedField) {
      const fieldData = this.fields.find(f => f.name === selectedField);
      return fieldData?.[param] ? fieldData?.[param] : false;
    }
    else {
      if (param === 'isDropDown') return true;
      else return false;
    }
  }
}